import React, { useEffect, useState } from "react";
import { Switch, withRouter } from "react-router-dom";
import SuperAdminRoutes from "./SuperAdminRoutes";
import AdminRoutes from "./AdminRoutes";
import RecruiterRoutes from "./RecruiterRoutes";
import FreelancerRoutes from "./FreelancerRoutes";
import useStyles from "../styles";
import { useLayoutState } from "../../../context/LayoutContext";
import { useTheme } from "@material-ui/styles";
import classNames from "classnames";
import CloseIcon from "@material-ui/icons/Close";
import { ToastContainer } from "react-toastify";

import { jwtDecode } from "jwt-decode";
import { UserDataProvider } from "../../../context/UserDataContext";
import { MuiThemeProvider, ThemeProvider } from "@material-ui/core/styles";

import Header from "../../Header";
import Sidebar from "../../Sidebar";
import VendorRoutes from "./VendorRoutes";
import ClientCoordinatorRoutes from "./ClientCoordinatorRoutes";
import EmployeeRoutes from "./EmployeeRoutes";
import EmployeeHeader from "../../Header/EmployeeHeader";
import { EmployeeDataProvider } from "../../../context/EmployeeDataContext";
import SuperAdminHeader from "../../Header/SuperAdminHeader";
import { customTheme } from "../muiTheme";

// Import other role-based route files

const AppRouter = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const layoutState = useLayoutState();

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const role = decoded.role;

  var [isPermanent, setPermanent] = useState(true);

  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.sm;
    var isSmallScreen = windowWidth < breakpointWidth;
    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }

  return (
    <div className={classes.root}>
      <MuiThemeProvider theme={customTheme}>
        <ThemeProvider theme={customTheme}>
          <UserDataProvider>
            <EmployeeDataProvider>
              <Sidebar />
              <div
                className={classNames(classes.content, {
                  [classes.contentShift]:
                    isPermanent && !layoutState.isSidebarOpened,
                  [classes.contentShift1]: layoutState.isSidebarOpened,
                })}
              >
                {["ADMIN", "SUBCONTRACT", "FREELANCER", "SUBVENDOR"].includes(
                  role,
                ) ? (
                  <div className={classes.fakeToolbar}>
                    <Header history={props.history} />
                  </div>
                ) : role === "SUPERADMIN" ? (
                  <div className={classes.fakeToolbar}>
                    <SuperAdminHeader history={props.history} />
                  </div>
                ) : role === "EMPLOYEE" ? (
                  <div className={classes.fakeToolbar}>
                    <EmployeeHeader history={props.history} />
                  </div>
                ) : (
                  <></>
                )}

                <Switch>
                  {/* Role-based routes */}
                  {role === "SUPERADMIN" && <SuperAdminRoutes role={role} />}
                  {role === "ADMIN" && <AdminRoutes role={role} />}
                  {role === "CLIENTCOORDINATOR" && (
                    <ClientCoordinatorRoutes role={role} />
                  )}
                  {role === "RECRUITER" && <RecruiterRoutes role={role} />}
                  {role === "EMPLOYEE" && <EmployeeRoutes role={role} />}
                  {(role === "SUBVENDOR" || role === "FREELANCER") && (
                    <FreelancerRoutes role={role} />
                  )}
                  {role === "SUBCONTRACT" && <VendorRoutes role={role} />}
                  {/* Add other role-based route conditions */}
                </Switch>
              </div>
            </EmployeeDataProvider>
          </UserDataProvider>

          <ToastContainer
            closeButton={
              <CloseButton className={classes.notificationCloseButton} />
            }
            closeOnClick={false}
            hideProgressBar={true}
          />
        </ThemeProvider>
      </MuiThemeProvider>
    </div>
  );
};

function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}

// function renderRoutesBasedOnCompanyType(companyType, role) {
//     if (companyType === "COMPANY") {
//         return (
//             <>
//                 <AuthRoute path="/app/projects" role={role} roles={["ADMIN", "CLIENTCOORDINATOR"]} component={Projects} />
//                 <AuthRoute path="/app/reports/vendor_onboarded_candidates" role={role} roles={["ADMIN"]} component={AllInvoiced} />
//             </>
//         );
//     }
//     else {
//         return (
//             <>
//                 <AuthRoute path="/app/clients" role={role} roles={["ADMIN"]} component={Clients} />
//                 <AuthRoute path="/app/resume_search" role={role} roles={["ADMIN"]} component={ResumeSearch} />
//                 {/* Reports */}
//                 <AuthRoute path="/app/reports/all_candidates_invoiced" role={role} roles={["ADMIN"]} component={AllInvoiced} />
//             </>
//         )
//     }
// }

export default withRouter(AppRouter);
